module.exports = __webpack_public_path__ + "img/logo-img.02c9967c.svg";